import React from 'preact/compat';

import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';

import { useAdvancedMode } from '../../state/advancedModeStore';
import colors from '../colors';

const LauncherAdvancedSwitch = () => {
    const [advancedMode, setAdvancedMode] = useAdvancedMode();

    const handleChange = (e, value) => {
        if (value !== null) {
            setAdvancedMode(value && value !== 'false');
        }
    };

    return (
        <ToggleButtonGroup
            value={advancedMode}
            exclusive
            onChange={handleChange}
            aria-label="Advanced Mode"
            sx={{
                height: '30px',
                border: 'none',
                borderWidth: '1px',
                borderColor: colors.featureBackground,
                borderStyle: 'solid',
                borderRadius: '4px',
                backgroundColor: colors.featureBackground,
                display: 'flex',
                alignItems: 'center',
                '& .MuiButtonBase-root': {
                    textTransform: 'capitalize',
                    border: 'none',
                    color: colors.primaryTextInverted,
                    height: '100%',
                    paddingTop: '2px',
                    paddingBottom: 0,
                    width: '109px',
                    '&.Mui-selected': {
                        borderRadius: '4px',
                        backgroundColor: colors.option,
                        color: colors.primaryText,
                        '&:hover': {
                            color: colors.primaryTextInverted,
                            backgroundColor: colors.optionHover
                        }
                    },
                    '&:hover': {
                        backgroundColor: colors.optionHover
                    }
                }
            }}
        >
            <ToggleButton value={false}>Basic</ToggleButton>
            <ToggleButton value={true}>Advanced</ToggleButton>
        </ToggleButtonGroup>
    );
};

export default LauncherAdvancedSwitch;
